import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";

import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { NumericFormat } from "react-number-format";
import "../../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../../assets/css/PrimeGrid.css";

import { AlertContext } from "../../../../context/AlertContext";
import { AuthContext } from "../../../../context/AuthContext";
import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import { getBrand, createBrandTheme } from "../../../../theme/brand";
import Spinner from "../../Spinner";
import Barra from "../../Barra";

const dosDec = (v) => parseFloat(v || 0).toFixed(2);

export default function Coseguros() {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [coseguro, guardarCoseguro] = useState(null);
  const [todasAp, guardarTodasAp] = useState(false);
  const [visible, setVisible] = useState(false);
  const [aEliminar, setAEliminar] = useState(null); // fila pendiente de confirmar borrado
  const toast = useRef(null);
  const navigate = useNavigate();

  const { mensajeAlerta } = useContext(AlertContext);
  const { state } = useContext(AuthContext);
  const {
    statusAcceso,
    coseguros,
    activeIndex,
    grupos,
    configuracion,
    obtenerCoseguros,
    obtenerAcceso,
    guardarCoseguros,
    setActiveIndex,
    obtenerGrupos,
    eliminarCoseguro,
    actualizarCoseguro,
  } = useContext(ConfiguracionContext);

  const theme = createBrandTheme(getBrand(configuracion));

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Coseguros" });
    }
    if (coseguros && coseguros.length === 0) {
      setActiveIndex(0);
      obtenerCoseguros({ grupo: 1 });
      obtenerGrupos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.id]);

  useEffect(() => {
    if (statusAcceso === 400) {
      mensajeAlerta(
        "Accesos",
        "No tiene permiso para acceder a esta pantalla !.",
        "error"
      );
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusAcceso]);

  const cargarGrupo = (idx) => {
    guardarCoseguros([]);
    setActiveIndex(idx);
    obtenerCoseguros({ grupo: Number(idx) + 1 });
  };

  const editClick = () => {
    if (!selectedRow) {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un coseguro.",
        life: 3000,
      });
      return;
    }
    guardarCoseguro(selectedRow);
    guardarTodasAp(false);
    setVisible(true);
  };

  const onHide = () => setVisible(false);

  const aceptarClick = () => {
    if (
      coseguro.valorDiurnoPediatrico < 0 ||
      coseguro.valorNocturnoPediatrico < 0 ||
      coseguro.valorDiurnoAdulto < 0 ||
      coseguro.valorNocturnoAdulto < 0
    ) {
      mensajeAlerta("Coseguros", "Los valores no pueden ser menores que cero !.", "error");
      return;
    }

    if (!todasAp) {
      actualizarCoseguro({ coseguro, todasAp });
      // Actualización optimista del array en memoria
      const cos = [...coseguros];
      const index = cos.findIndex((item) => item.id === coseguro.id);
      if (index >= 0) {
        cos[index] = {
          ...cos[index],
          valorDiurnoPediatrico: coseguro.valorDiurnoPediatrico,
          valorNocturnoPediatrico: coseguro.valorNocturnoPediatrico,
          valorDiurnoAdulto: coseguro.valorDiurnoAdulto,
          valorNocturnoAdulto: coseguro.valorNocturnoAdulto,
        };
        guardarCoseguros(cos);
      }
    } else {
      const cosNuevo = coseguros
        .filter((item) => item.servicioId === coseguro.servicioId)
        .map((item) => ({
          ...item,
          valorDiurnoPediatrico: coseguro.valorDiurnoPediatrico,
          valorNocturnoPediatrico: coseguro.valorNocturnoPediatrico,
          valorDiurnoAdulto: coseguro.valorDiurnoAdulto,
          valorNocturnoAdulto: coseguro.valorNocturnoAdulto,
        }));

      actualizarCoseguro({ coseguro, todasAp, cosNuevo });
      setTimeout(() => window.location.reload(), 3000);
    }

    onHide();
    setSelectedRow(null);
  };

  const confirmarEliminar = () => {
    if (!selectedRow) {
      toast.current.show({
        severity: "info",
        summary: "Eliminar",
        detail: "Debe seleccionar un coseguro.",
        life: 3000,
      });
      return;
    }
    setAEliminar(selectedRow);
  };

  const eliminar = () => {
    eliminarCoseguro(aEliminar.id);
    setAEliminar(null);
    obtenerCoseguros({ grupo: Number(activeIndex) + 1 });
  };

  const exitClick = () => navigate("/");

  // ¿La pestaña actual es "Planes" (grupo con id 1)?
  const esPlanes = grupos && grupos[activeIndex] && grupos[activeIndex].id === 1;
  const tituloEliminar = aEliminar
    ? (aEliminar.planNombre !== undefined
        ? aEliminar.planNombre
        : aEliminar.afiliadoNombre) +
      " " +
      aEliminar.servicioNombre
    : "";

  const valorTemplate = (campo) => (rowData) => dosDec(rowData[campo]);

  const cargando =
    statusAcceso === 0 ||
    statusAcceso === 400 ||
    !coseguros ||
    coseguros.length === 0;

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />

      {cargando ? <Spinner /> : null}

      {statusAcceso === 200 && coseguros && coseguros.length > 0 ? (
        <ThemeProvider theme={theme}>
          <Box id="dataTableBotones" sx={{ px: { xs: 1, sm: 2 }, pb: 3 }}>
            <Paper
              elevation={0}
              sx={{
                p: 2,
                mb: 2,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
              }}
            >
              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                alignItems={{ xs: "stretch", md: "center" }}
              >
                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flexShrink: 0 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: 2,
                      display: "grid",
                      placeItems: "center",
                      bgcolor: "primary.main",
                      color: "primary.contrastText",
                    }}
                  >
                    <PaymentsOutlinedIcon />
                  </Box>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                      Coseguros
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {`${coseguros.length} registros`}
                    </Typography>
                  </Box>
                </Stack>

                <Box sx={{ flexGrow: 1 }} />

                <TextField
                  size="small"
                  placeholder="Buscar…"
                  onInput={(e) => setGlobalFilter(e.target.value)}
                  sx={{ minWidth: { xs: "100%", md: 240 } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>

              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 2 }}>
                <Button
                  variant="contained"
                  startIcon={<EditOutlinedIcon />}
                  onClick={editClick}
                  disabled={!selectedRow}
                >
                  Editar
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<DeleteOutlineIcon />}
                  onClick={confirmarEliminar}
                  disabled={!selectedRow}
                >
                  Eliminar
                </Button>
                <Box sx={{ flexGrow: 1 }} />
                <Button
                  variant="text"
                  color="inherit"
                  startIcon={<CloseIcon />}
                  onClick={exitClick}
                >
                  Cerrar
                </Button>
              </Stack>
            </Paper>

            <Paper
              elevation={0}
              sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <Tabs
                value={grupos && grupos.length ? activeIndex : false}
                onChange={(e, idx) => cargarGrupo(idx)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ borderBottom: "1px solid", borderColor: "divider", px: 1 }}
              >
                {(grupos || []).map((g) => (
                  <Tab
                    key={g.id}
                    label={
                      g.id === 1
                        ? "Planes"
                        : g.nombre.charAt(0).toUpperCase() +
                          g.nombre.slice(1).toLowerCase()
                    }
                  />
                ))}
              </Tabs>

              <DataTable
                value={coseguros}
                selection={selectedRow}
                onSelectionChange={(e) => setSelectedRow(e.value)}
                selectionMode="single"
                dataKey="id"
                className="p-datatable-sm p-datatable-striped p-datatable-responsive-demo mito-grid"
                globalFilter={globalFilter}
                emptyMessage="No hay datos."
                paginator
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                rows={10}
                rowsPerPageOptions={[10, 20, 50]}
              >
                {esPlanes ? (
                  <Column field="planNombre" header="Plan" sortable />
                ) : (
                  <Column field="afiliadoId" header="ID Afiliado" sortable style={{ width: "9rem" }} />
                )}
                {esPlanes ? null : (
                  <Column field="afiliadoNombre" header="Afiliado" sortable />
                )}
                <Column field="servicioNombre" header="Servicios" sortable />
                <Column
                  field="valorDiurnoPediatrico"
                  header="Valor Diurno Pediátrico"
                  body={valorTemplate("valorDiurnoPediatrico")}
                  sortable
                />
                <Column
                  field="valorNocturnoPediatrico"
                  header="Valor Nocturno Pediátrico"
                  body={valorTemplate("valorNocturnoPediatrico")}
                  sortable
                />
                <Column
                  field="valorDiurnoAdulto"
                  header="Valor Diurno Adulto"
                  body={valorTemplate("valorDiurnoAdulto")}
                  sortable
                />
                <Column
                  field="valorNocturnoAdulto"
                  header="Valor Nocturno Adulto"
                  body={valorTemplate("valorNocturnoAdulto")}
                  sortable
                />
              </DataTable>
            </Paper>
          </Box>

          {/* Diálogo de edición */}
          <Dialog open={visible} onClose={onHide} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, fontWeight: 700 }}>
              <PaymentsOutlinedIcon color="primary" />
              Editar coseguro
            </DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={2} sx={{ mt: 0 }}>
                {coseguro && coseguro.grupoId > 1 ? (
                  <Grid item xs={12}>
                    <TextField
                      value={coseguro.afiliadoId ?? ""}
                      label="ID Afiliado"
                      fullWidth
                      size="small"
                      disabled
                    />
                  </Grid>
                ) : null}
                <Grid item xs={12}>
                  <TextField
                    value={
                      coseguro
                        ? coseguro.grupoId === 1
                          ? coseguro.planNombre ?? ""
                          : coseguro.afiliadoNombre ?? ""
                        : ""
                    }
                    label={coseguro && coseguro.grupoId === 1 ? "Plan" : "Nombre"}
                    fullWidth
                    size="small"
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    value={coseguro ? coseguro.servicioNombre ?? "" : ""}
                    label="Servicio"
                    fullWidth
                    size="small"
                    disabled
                  />
                </Grid>

                {[
                  ["valorDiurnoPediatrico", "Valor Diurno Pediátrico"],
                  ["valorNocturnoPediatrico", "Valor Nocturno Pediátrico"],
                  ["valorDiurnoAdulto", "Valor Diurno Adulto"],
                  ["valorNocturnoAdulto", "Valor Nocturno Adulto"],
                ].map(([campo, label]) => (
                  <Grid item xs={12} sm={6} key={campo}>
                    <NumericFormat
                      id={campo}
                      label={label}
                      customInput={TextField}
                      value={coseguro ? dosDec(coseguro[campo]) : ""}
                      fullWidth
                      size="small"
                      valueIsNumericString
                      onChange={(e) =>
                        guardarCoseguro({ ...coseguro, [campo]: e.target.value })
                      }
                    />
                  </Grid>
                ))}

                {coseguro && coseguro.grupoId === 2 ? (
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={todasAp}
                          onChange={(e) => guardarTodasAp(e.target.checked)}
                        />
                      }
                      label="Aplicar a todas las A.P."
                    />
                  </Grid>
                ) : null}
              </Grid>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
              <Button onClick={onHide} color="inherit" startIcon={<CloseIcon />}>
                Cancelar
              </Button>
              <Button onClick={aceptarClick} variant="contained" startIcon={<CheckIcon />}>
                Guardar
              </Button>
            </DialogActions>
          </Dialog>

          {/* Diálogo de confirmación de borrado */}
          <Dialog open={Boolean(aEliminar)} onClose={() => setAEliminar(null)} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontWeight: 700 }}>Confirmación</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {`¿Confirma eliminar coseguro ${tituloEliminar} ?`}
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
              <Button onClick={() => setAEliminar(null)} color="inherit" startIcon={<CloseIcon />}>
                No
              </Button>
              <Button onClick={eliminar} variant="contained" color="error" startIcon={<DeleteOutlineIcon />}>
                Eliminar
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      ) : null}
    </Fragment>
  );
}
